import React, { useMemo } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, EffectFade, Autoplay } from 'swiper'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'

import 'swiper/css'
import 'swiper/css/effect-fade'
import { getBannerList_marketingModule_bannerList } from '~/graphqls/types'

const StyledSwiper = styled(Swiper)`
  position: relative;
  margin-bottom: 40px;
  .swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
  .swiper-pagination-bullet {
    width: 20px;
    height: 4px;
    border-radius: 2px;
    background: ${props => props.theme.light1};
    &.swiper-pagination-bullet-active {
      background: ${props => props.theme.primaryColor};
    }
  }
  .banner-image {
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    background: ${props => props.theme.light3};
  }
`

export interface BannerDataprops {
  img: string
  link: string
}

export const BannerModule: React.FC<{
  data: getBannerList_marketingModule_bannerList[]
  height?: number
}> = ({ data, height = 450 }) => {
  const onlyOne = useMemo(() => {
    return data.length === 1
  }, [data])

  return (
    <StyledSwiper
      style={{
        paddingBottom: onlyOne ? 0 : 28,
      }}
      pagination={
        onlyOne
          ? false
          : {
              clickable: true,
            }
      }
      effect={'fade'}
      loop={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      modules={[EffectFade, Autoplay, Pagination]}
    >
      {data.map((item, index: number) => (
        <SwiperSlide key={index}>
          {!!item.redirectUrl ? (
            <a
              href={item.redirectUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              <MyImage
                tag="v2400"
                lazy={false}
                className="banner-image"
                style={{ height: height }}
                src={item.imageUrl}
              />
            </a>
          ) : (
            <MyImage
              tag="v2400"
              lazy={false}
              className="banner-image"
              style={{ height: height }}
              src={item.imageUrl}
            />
          )}
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}
